import { APP_SIZES, DRAGGABLE_TYPES } from "Common/componentUtils/constants";
import { SORT_ORDER } from "Common/dictionaries/sortOrder";
import head from "lodash/head";
import toUpper from "lodash/toUpper";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { SidebarMenuList, SidebarMenuTabs, SidebarSearchPanel, Styled } from "../Common";
import locale from "./summaryReportSidebarMenu.locale";
import { buildSidebarItems } from "./utils";
const availableSortBy = [{ Key: "title", Name: locale.SORT_BY_TITLE }];
export default function SummaryReportSidebarMenu(props) {
    var _a;
    const [filterText, setFilterText] = useState("");
    const [sortBy, setSortBy] = useState((_a = head(availableSortBy)) === null || _a === void 0 ? void 0 : _a.Key);
    const [sortOrder, setSortOrder] = useState(SORT_ORDER.ASC);
    useEffect(() => {
        props.summaryReportId && props.onInitialized && props.onInitialized(props.summaryReportId);
    }, [props.summaryReportId]);
    const sidebarMenuItems = useMemo(() => {
        if (!props.summaryReportId || !props.data)
            return undefined;
        return buildSidebarItems(props.data, DRAGGABLE_TYPES.DOCUMENT_OBJECT);
    }, [props.summaryReportId, props.data]);
    const handleToggleSortOrder = useCallback(() => {
        setSortOrder(prev => (prev === SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC));
    }, []);
    const handleChangeSortBy = useCallback((value) => {
        setSortBy(value);
    }, []);
    const searchPanel = useMemo(() => (React.createElement(Styled.LogoContainer, { className: "unselectable", sidebarWidth: props.width ? props.width - APP_SIZES.SIDEBAR_COLLAPSED_WIDTH : 0 },
        React.createElement("h6", { className: "text-gray-500 font-thin mb-1" }, toUpper(locale.SIDEBAR_TITLE)),
        React.createElement(SidebarSearchPanel, { searchClassName: "darker-texteditor", filterText: filterText, onFilterTextChange: setFilterText, availableSortBy: availableSortBy, sortBy: sortBy, sortOrder: sortOrder, onToggleSortOrder: handleToggleSortOrder, onChangeSortBy: handleChangeSortBy }))), [props.width, filterText, sortBy, sortOrder, handleToggleSortOrder, handleChangeSortBy]);
    return (React.createElement(Styled.SidebarMenuContainer, { width: props.width, className: props.className, bgColorDefault: "navbar-bg" },
        React.createElement(SidebarMenuTabs, { defaultHash: props.defaultHash, productName: props.productName, rows: 2 }),
        searchPanel,
        React.createElement(SidebarMenuList, { filterText: filterText, sortBy: sortBy, sortOrder: sortOrder, bgColorDefault: "navbar-bg", bgColorActive: "navbar-bg-lightest", inProgress: props.inProgress, sidebarMenuItems: sidebarMenuItems, emptyText: locale.NO_SUMMARY_REPORT_OBJECTS })));
}
